module.exports = __webpack_public_path__ + "img/solidpayments.4e35aa60.svg";